import React, { Suspense } from "react";
import { PropTypes } from "prop-types";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import Spinner from "../../../../../common/Spinner";
import ErrorComponent from "../../../../../common/ErrorComponent";
import { useI18n } from "../../../../../i18n/useI18n";

const [HbrTable, HbrSpinner] = reactWrapper([
  "hbr-table",
  "hbr-input",
  "hbr-icon",
  "hbr-pagination",
  "hbr-spinner",
  "hbr-button",
]);

const TableView = (props) => {
  const { tViews } = useI18n("views");
  const { source, columns, query } = props.tableStore.getState();
  props.isTopClientsTableCallback?.(true);

  return (
    <div className="table-container hbr-css__layout-col-md">
      <HbrTable
        id="tc-table"
        serverSide={true}
        source={source}
        columns={columns}
        useClipboard={false}
        canFocus={false}
        style={{
          height:
            source.length > 50
              ? source.length * 38 + "px"
              : source.length * 48 + "px",
          width: "100%",
          paddingBottom: "20px",
          minHeight: "500px",
        }}
        externalSorting={true}
        onHbr-before-sort={(event) => {
          const { column, order } = event.detail;
          if (order) {
            props.tableStore.hooks[0].sort({ order: [[column.id, order]] });
          } else {
            if (column.id.includes(query.order[0][0])) {
              if (query.order[0][1] === "desc") {
                props.tableStore.hooks[0].sort({
                  order: [[column.id, "asc"]],
                });
              } else {
                props.tableStore.hooks[0].sort({
                  order: [[column.id, "desc"]],
                });
              }
            } else {
              props.tableStore.hooks[0].sort({ order: props.defaultSort });
            }
          }
        }}
      >
        {props.tableLoader && source.length === 0 && (
          <div slot="empty" className="hbr-css__table-empty-state">
            <HbrSpinner direction="column" size="small">
              <div slot="label">{tViews("loading")}</div>
            </HbrSpinner>
          </div>
        )}
        {source.length === 0 && props.tableLoader === false && (
          <div slot="empty" className="hbr-css__table-empty-state">
            {source.length === 0 && props.tableError === null ? (
              <>
                <hbr-icon id="tc-empty-icon" name="hbr-empty-state"></hbr-icon>
                <span className="hbr-css__text-secondary-sm">
                  {tViews("logs.emptyData")}
                </span>
              </>
            ) : (
              <Suspense fallback={<Spinner />}>
                <ErrorComponent
                  {...props.tableError}
                  className="small-dashlet-error"
                  width="200px"
                />
              </Suspense>
            )}
          </div>
        )}
      </HbrTable>
    </div>
  );
};

TableView.propTypes = {
  tableStore: PropTypes.object.isRequired,
  defaultSort: PropTypes.array,
  tableLoader: PropTypes.bool,
  tableError: PropTypes.object,
  isTopClientsTableCallback: PropTypes.func,
};

export default TableView;
